//* Main game for Ratris

import Phaser from 'phaser'
import { gSettings } from '../settings/gamesettings';
import  TetGrid from '../classes/TetGrid.js';
import  gridPlayer from '../classes/GridPlayer.js';
import  ratUI from '../classes/ratUI.js';

import * as blk from '../classes/TetShapes.js'
import * as mJS from  '../common/mvUtils.js'

// import textures
import tileblank_url from '../assets/tile16_Blank.png';
import tile0_url from '../assets/tile16_0.png';
import tile1_url from '../assets/tile16_1.png';
import tile2_url from '../assets/tile16_2.png';
import tile3_url from '../assets/tile16_3.png';
import tile4_url from '../assets/tile16_4.png';
import tile5_url from '../assets/tile16_5.png';
import tile6_url from '../assets/tile16_6.png';
import tile7_url from '../assets/tile16_7.png';
import tile8_url from '../assets/tile16_8.png';
import tile9_url from '../assets/tile16_9.png';
import tile9_url from '../assets/tile16_9.png';

// importRat tiles
import RatClimbA_url from '../assets/RatClimbA.png';
import RatClimbB_url from '../assets/RatClimbB.png';
import RatDieA_url   from '../assets/RatDieA.png';
import RatFallA_url  from '../assets/RatFallA.png';
import RatFallB_url  from '../assets/RatFallB.png';
import RatNestA_url  from '../assets/RatNestA.png';
import RatNestB_url  from '../assets/RatNestB.png';
import RatRunA_url   from '../assets/RatRunA.png';
import RatRunB_url   from '../assets/RatRunB.png';
import RatRunC_url   from '../assets/RatRunC.png';
import RatRunD_url   from '../assets/RatRunD.png';

// load UI stuff
import RatBG_url   from '../assets/RatBG.jpg';
//import UITemp_url   from '../assets/UITemp.png';
import UITree_url 	from '../assets/RatTree.png';
import RatLogo_url	from '../assets/SNLogo.png';
import RatKara_url	from '../assets/RatKaraImg.png';
import GameOver_url	from '../assets/GOImg.png';

import SlidePanel_url	from '../assets/SlidePanelBlank.png';

// load sprite sheets
import aniFadeLine_url from '../assets/FadeLineTile_SS_16x16.png';
import aniSmoke_url from '../assets/smoke_SS_8x8.png';

import aniM1_Run_url from '../assets/SS_M1_Runx16x32x4.png';
import aniM1_Fall_url from '../assets/SS_M1_Fallx16x32x4.png';
import aniM1_Die_url from '../assets/SS_M1_Diex16x16x1.png';
import aniM1_Nest_url from '../assets/SS_M1_Nestx16x32x10.png';

import aniM2_Run_url from '../assets/SS_M2_Runx16x32x4.png';
import aniM2_Fall_url from '../assets/SS_M2_Fallx16x32x4.png';
import aniM2_Die_url from '../assets/SS_M2_Diex16x16x1.png';
import aniM2_Nest_url from '../assets/SS_M2_Nestx16x32x10.png';

import aniM3_Run_url from '../assets/SS_M3_Runx16x32x4.png';
import aniM3_Fall_url from '../assets/SS_M3_Fallx16x32x4.png';
import aniM3_Die_url from '../assets/SS_M3_Diex16x16x1.png';
import aniM3_Nest_url from '../assets/SS_M3_Nestx16x32x10.png';

// Load Sounds
//import sounds from '../assets/*.wav';
//let Bonus_Snd_url = require('../assets/RatBonus.wav');

const Bonus_Snd_url = new URL('../assets/RatBonus.wav', import.meta.url);
const BrickPlace_Snd_url  = new URL( '../assets/RatBrickPlace.wav', import.meta.url );
const RatMove_Snd_url     = new URL( '../assets/RatMove.wav'      , import.meta.url );
const RatSpawn_Snd_url    = new URL( '../assets/Ratspawn.wav'     , import.meta.url );
const RatStart_Snd_url    = new URL( '../assets/RatStart.wav'     , import.meta.url );
const RatDie_Snd_url    = new URL( '../assets/RatDeath.wav'     , import.meta.url );
const RatNest_Snd_url    = new URL( '../assets/RatNestCry.wav'     , import.meta.url );
const RatGameOver_Snd_url    = new URL( '../assets/RatGameOver.wav'     , import.meta.url );


/*
var Bonus_Snd_url 		= require( '../assets/RatBonus.wav'      );
var BrickPlace_Snd_url  = require( '../assets/RatBrickPlace.wav' );
var RatMove_Snd_url     = require( '../assets/RatMove.wav'       );
var RatSpawn_Snd_url    = require( '../assets/Ratspawn.wav'      );
var RatStart_Snd_url    = require( '../assets/RatStart.wav'      );
*/

/*
import Bonus_Snd_url from '../assets/RatBonus.wav';
import BrickPlace_Snd_url from '../assets/RatBrickPlace.wav';
import RatMove_Snd_url from '../assets/RatMove.wav';
import RatSpawn_Snd_url from '../assets/Ratspawn.wav';
import RatStart_Snd_url from '../assets/RatStart.wav';
*/



// put globals here
const 	grid = new TetGrid("Ratris", gSettings.GAME_GRID_SIZE_X, gSettings.GAME_GRID_SIZE_Y);
const 	p1 = new gridPlayer(1,mJS.getRandomInt(0,2));
const   UI = new ratUI();

var debugText;
var movingTextArr = [];
var debugKey = 0;
var DEBUG = 0;
var bottomOfGrid = 0;
var xPositionOfGrid = 0;
var debugGrid = true;
var gTime = 0;
var topScore = 1000;
// sprite groups
var blocks;
var nextBlocks;
var ratSprites;
var sprFXs;
var newGame = true;
var TITLE_SCREEN_ON = true;
var TITLE_DELAY_AMOUNT = 2000;
var TITLE_DELAY_TIME = 0;    
var GAME_ON = false;
var GAME_OVER_WAIT = 2000;
var GAME_OVER_REINIT = false
var sndLib = [];


const Sound = Object.freeze({ 
    bonus: 0, 
    placeBrick: 1, 
    brickMove: 2, 
    ratSpawn: 3, 
    startGame: 4, 
	ratDie: 5,
	ratNest: 6,
	ratGameOver: 7
}); 

export default class gameScene extends Phaser.Scene
{


	constructor ()
    {
        super();
    }
		


	init() {

		// map keys
		p1.moveLeft 	= this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.LEFT);
		p1.moveRight	= this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.RIGHT);
		p1.rotLeft 	= this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.Z);
		p1.rotRight 	= this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.X);
		p1.hardDrop   = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
		p1.hardDropAlt   = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.UP);
		p1.slowDrop   = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.C);
		p1.slowDropAlt   = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.DOWN);
		p1.moveUp   = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.D);
		

;

	}

	preload()
	{
		

		this.load.image("blank.gfx", tileblank_url);
		this.load.image("tile0.gfx", tile0_url);
		this.load.image("tile1.gfx", tile1_url);
		this.load.image("tile2.gfx", tile2_url);
		this.load.image("tile3.gfx", tile3_url);
		this.load.image("tile4.gfx", tile4_url);
		this.load.image("tile5.gfx", tile5_url);
		this.load.image("tile6.gfx", tile6_url);
		this.load.image("tile7.gfx", tile7_url);
		this.load.image("tile8.gfx", tile8_url);
		this.load.image("tile9.gfx", tile9_url);
		


		this.load.image("RatClimbA.gfx", RatClimbA_url);
		this.load.image("RatClimbB.gfx", RatClimbB_url);
		this.load.image("RatDieA.gfx", RatDieA_url);
		this.load.image("RatFallA.gfx", RatFallA_url);
		this.load.image("RatFallB.gfx", RatFallB_url);
		this.load.image("RatNestA.gfx", RatNestA_url);
		this.load.image("RatNestB.gfx", RatNestB_url);
		this.load.image("RatRunA.gfx", RatRunA_url);
		this.load.image("RatRunB.gfx", RatRunB_url);
		this.load.image("RatRunC.gfx", RatRunC_url);
		this.load.image("RatRunD.gfx", RatRunD_url);


		
		this.load.spritesheet('fadeLineAni.gfx', aniFadeLine_url, { frameWidth: gSettings.TILE_SIZE + 1, frameHeight:  gSettings.TILE_SIZE  });
		this.load.spritesheet('smokeAni.gfx', aniSmoke_url, { frameWidth:(gSettings.TILE_SIZE / 2) + 1, frameHeight:  (gSettings.TILE_SIZE /2)  });
		
		this.load.spritesheet('aniM1_Run.gfx', aniM1_Run_url, { frameWidth:gSettings.TILE_SIZE, frameHeight:  gSettings.TILE_SIZE   });
		this.load.spritesheet('aniM1_Fall.gfx', aniM1_Fall_url, { frameWidth:gSettings.TILE_SIZE, frameHeight:  gSettings.TILE_SIZE   });
		this.load.spritesheet('aniM1_Die.gfx', aniM1_Die_url, { frameWidth:gSettings.TILE_SIZE, frameHeight:  gSettings.TILE_SIZE   });
		this.load.spritesheet('aniM1_Nest.gfx', aniM1_Nest_url, { frameWidth:gSettings.TILE_SIZE, frameHeight:  gSettings.TILE_SIZE   });
	
		this.load.spritesheet('aniM2_Run.gfx', aniM2_Run_url, { frameWidth:gSettings.TILE_SIZE, frameHeight:  gSettings.TILE_SIZE   });
		this.load.spritesheet('aniM2_Fall.gfx', aniM2_Fall_url, { frameWidth:gSettings.TILE_SIZE, frameHeight:  gSettings.TILE_SIZE   });
		this.load.spritesheet('aniM2_Die.gfx', aniM2_Die_url, { frameWidth:gSettings.TILE_SIZE, frameHeight:  gSettings.TILE_SIZE   });
		this.load.spritesheet('aniM2_Nest.gfx', aniM2_Nest_url, { frameWidth:gSettings.TILE_SIZE, frameHeight:  gSettings.TILE_SIZE   });
	
		this.load.spritesheet('aniM3_Run.gfx', aniM3_Run_url, { frameWidth:gSettings.TILE_SIZE, frameHeight:  gSettings.TILE_SIZE   });
		this.load.spritesheet('aniM3_Fall.gfx', aniM3_Fall_url, { frameWidth:gSettings.TILE_SIZE, frameHeight:  gSettings.TILE_SIZE   });
		this.load.spritesheet('aniM3_Die.gfx', aniM3_Die_url, { frameWidth:gSettings.TILE_SIZE, frameHeight:  gSettings.TILE_SIZE   });
		this.load.spritesheet('aniM3_Nest.gfx', aniM3_Nest_url, { frameWidth:gSettings.TILE_SIZE, frameHeight:  gSettings.TILE_SIZE   });

		
		//UI.preload();

		// UI STUFF
		this.load.image('RatBG.gfx', RatBG_url);
		//this.load.image('UITemp.gfx',UITemp_url );
		this.load.image('UITree.gfx', UITree_url);
		this.load.image('RatLogo.gfx',RatLogo_url); 
		this.load.image('RatKara.gfx',RatKara_url);
		this.load.image('SlidePanel.gfx',SlidePanel_url);
		this.load.image('GameOver.gfx', GameOver_url);

		// Sound 
		// STRANGE HACK TO GET SOUNDS
		this.load.audio('Bonus.sfx', [ Bonus_Snd_url.pathname]);
		this.load.audio('Bonus.sfx', [ Bonus_Snd_url.pathname]);
		this.load.audio('BrickPlace.sfx', [ BrickPlace_Snd_url.pathname]);
		this.load.audio('BrickMove.sfx', [ RatMove_Snd_url.pathname]);
		this.load.audio('RatSpawn.sfx', [ RatSpawn_Snd_url.pathname]);
		this.load.audio('StartGame.sfx', [ RatStart_Snd_url.pathname]);
		this.load.audio('RatDie.sfx', [ RatDie_Snd_url.pathname]);
		this.load.audio('RatNest.sfx', [ RatNest_Snd_url.pathname]);
		this.load.audio('RatGameOver.sfx', [ RatGameOver_Snd_url.pathname]);
		
	}

	create()
	{
		
		// TODO put this in a Class like UI
		sndLib.push(this.sound.add('Bonus.sfx'));    
		sndLib.push(this.sound.add('BrickPlace.sfx', {volume : 0.7} ));
		sndLib.push(this.sound.add('BrickMove.sfx'));
		sndLib.push(this.sound.add('RatSpawn.sfx'));
		sndLib.push(this.sound.add('StartGame.sfx'));
		sndLib.push(this.sound.add('RatDie.sfx'));
		sndLib.push(this.sound.add('RatNest.sfx', {volume : 0.5} ));
		sndLib.push(this.sound.add('RatGameOver.sfx', {volume : 0.5} ));
		


		debugText = this.add.text(450, 300, "debug");
		var textConfig = {	fontFamily:'PixeloidMono',	fontSize:100,	color:'#ffffff'	}

		movingTextArr.push(this.add.text(0, gSettings.GAME_Y_RES + 1000, textConfig ))
		movingTextArr.push(this.add.text(10, gSettings.GAME_Y_RES + 1000, textConfig))
		movingTextArr.push(this.add.text(20, gSettings.GAME_Y_RES + 1000, textConfig))
		movingTextArr.push(this.add.text(30, gSettings.GAME_Y_RES + 1000, textConfig))
		movingTextArr.push(this.add.text(40, gSettings.GAME_Y_RES + 1000, textConfig))


		// define groups
		nextBlocks = this.add.group(); // blocks for the next 
		sprFXs = this.add.group();
		blocks = this.add.group();
		ratSprites = this.add.group();


		this.anims.create({
            key: 'fadeLineAni', 
			frames:  this.anims.generateFrameNumbers('fadeLineAni.gfx', { frames: [ 0,1,2,3,4,5,6,7,8 ] }),
            frameRate: 20
		//	repeat: -1 // -1 for look
        });
	
		this.anims.create({
            key: 'smokeAni', 
			frames:  this.anims.generateFrameNumbers('smokeAni.gfx', { frames: [ 0,1,2,3,4,5,6] }),
            frameRate: 20
		//	repeat: -1 // -1 for look
        });

		
		let animalSpeed = 7;

		this.anims.create({
            key: 'aniM1Run', 
			frames:  this.anims.generateFrameNumbers('aniM1_Run.gfx', { frames: [ 0,2,4] }),
            frameRate: animalSpeed,
			repeat: -1 // -1 for loop
        });

		this.anims.create({
            key: 'aniM1Fall', 
			frames:  this.anims.generateFrameNumbers('aniM1_Fall.gfx', { frames: [ 0,2,4] }),
            frameRate: animalSpeed,
			repeat: -1 // -1 for loop
        });

		this.anims.create({
            key: 'aniM1Die', 
			frames:  this.anims.generateFrameNumbers('aniM1_Die.gfx', { frames: [ 0] }),
            frameRate: animalSpeed,
			repeat: -1 // -1 for loop
        });

		this.anims.create({
            key: 'aniM1Nest', 
			frames:  this.anims.generateFrameNumbers('aniM1_Nest.gfx', { frames: [ 2,4,6,8,10,12,14] }),
            frameRate: animalSpeed,
			repeat: -1 // -1 for loop
        });




		this.anims.create({
            key: 'aniM2Run', 
			frames:  this.anims.generateFrameNumbers('aniM2_Run.gfx', { frames: [ 0,2,4] }),
            frameRate: animalSpeed,
			repeat: -1 // -1 for loop
        });



		this.anims.create({
            key: 'aniM2Fall', 
			frames:  this.anims.generateFrameNumbers('aniM2_Fall.gfx', { frames: [ 0,2,4] }),
            frameRate: animalSpeed,
			repeat: -1 // -1 for loop
        });

		this.anims.create({
            key: 'aniM2Die', 
			frames:  this.anims.generateFrameNumbers('aniM2_Die.gfx', { frames: [ 0] }),
            frameRate: animalSpeed,
			repeat: -1 // -1 for loop
        });

		this.anims.create({
            key: 'aniM2Nest', 
			frames:  this.anims.generateFrameNumbers('aniM2_Nest.gfx', { frames: [ 2,4,6,8,10,12,14] }),
            frameRate: animalSpeed,
			repeat: -1 // -1 for loop
        });



		this.anims.create({
            key: 'aniM3Run', 
			frames:  this.anims.generateFrameNumbers('aniM3_Run.gfx', { frames: [ 0,2,4] }),
            frameRate: animalSpeed,
			repeat: -1 // -1 for loop
        });

		this.anims.create({
            key: 'aniM3Fall', 
			frames:  this.anims.generateFrameNumbers('aniM3_Fall.gfx', { frames: [ 0,2,4] }),
            frameRate: animalSpeed,
			repeat: -1 // -1 for loop
        });

		this.anims.create({
            key: 'aniM3Die', 
			frames:  this.anims.generateFrameNumbers('aniM3_Die.gfx', { frames: [ 0] }),
            frameRate: animalSpeed,
			repeat: -1 // -1 for loop
        });

		this.anims.create({
            key: 'aniM3Nest', 
			frames:  this.anims.generateFrameNumbers('aniM3_Nest.gfx', { frames: [ 2,4,6,8,10,12,14] }),
            frameRate: animalSpeed,
			repeat: -1 // -1 for loop
        });

	
		UI.create(this);


		// load in top score from local storage if it doesn't exist set it to 1000
		topScore = parseInt(localStorage.getItem('topScore')) || 1000;
	

	}
	



	update(time, delta) {

		if (newGame == true) {
			newGame = false;

			grid.spawnRat(0,2);

			for (let i = 0; i < gSettings.GAME_GRID_SIZE_X;i++) {
		
				
				grid.insert(i, gSettings.GAME_GRID_SIZE_Y -1,1);
				grid.insert(7, gSettings.GAME_GRID_SIZE_Y -1,0);
			}

		}


		gTime = time;
		
		grid.removeRatsFromArray();
		grid.insertBlk(p1.brickData,p1.curPosX,p1.curPosY, p1.curRot, -p1.playerNo);


		// TODO turn players into an array
		if (GAME_OVER_WAIT < time) {
			p1.inputChk(time, delta);
		}

		this.UIInputChk(time, p1);

		if (TITLE_SCREEN_ON) { 
	
			if (p1.velX != 0 || p1.velR != 0 || p1.hardDropOn == true ) {
			
				GAME_ON = true;
				TITLE_SCREEN_ON = false; 
				p1.velR = 0;
				p1.velX = 0;
				p1.velY = 0;
				p1.hardDropOn = false;
				p1.refresh = false;
				TITLE_DELAY_TIME = time + TITLE_DELAY_AMOUNT;
				UI.TitleState = 2;
				sndLib[Sound.startGame].play();

				p1.initPlayer(1);
				let color = mJS.getRandomInt(0,4);
				if (color == 0) {
					p1.color = 0x920072;
				}
				if (color == 1) {
					p1.color = 0x24ba94;
				}
				if (color == 2) {
					p1.color = 0xf4e8c7;
				}
				if (color == 3) {
					p1.color = 0xEBD9EF;
				}
				if (color == 4) {
					p1.color = 0xB6E1B8;
				}
			}
		}
/*
		if (TITLE_DELAY_TIME < time) {
			GAME_ON = true;
			
		}
*/
		if (GAME_ON) {

		if (p1.ratScore > topScore) { topScore = p1.ratScore;
			localStorage.setItem('topScore', topScore);
		}
		// update player  position
		if (p1.velX != 0 || p1.velY != 0 || p1.velR != 0 || p1.refresh == true ) {

			



			if (TITLE_DELAY_TIME > time) {
				p1.velR = 0;
				p1.velX = 0;
				p1.velY = 0;
				p1.hardDropOn = false;
				p1.refresh = false;
			}
			if (p1.velX != 0 || p1.velY != 0 || p1.velR != 0) {
				sndLib[Sound.brickMove].play();
			}

			let result = 0;
			
			// refresh
			if (p1.refresh) {
		
				p1.refresh  = false;
				
				result = grid.checkBlk(p1.brickData,  p1.curPosX, p1.curPosY, p1.velX, p1.velY, p1.curRot) ;
				
				if (result > 0) { // GAME OVER 
					if (gSettings.RAT_SCORE_SYSTEM) {
						if (topScore < p1.ratScore) topScore = p1.ratScore;
					} else {
						if (topScore < p1.score) topScore = p1.score;
					}
					// LOAD GAME OVER
					TITLE_SCREEN_ON = true;
					GAME_ON = false;
					GAME_OVER_WAIT = time + 7000;
					grid.zero();
					this.drawNext(p1,840, 85, gSettings.DRAW_NEXT_AMOUNT, true)
					UI.TitleState = 4;
					for(let k = 0; k < movingTextArr.length; k++) {
						movingTextArr[k].setText(" "); 
					}
					newGame = true;
					sndLib[Sound.ratGameOver].play();

				} 
				grid.findAndReplaceFromArray(-p1.playerNo,0);
				grid.insertBlk(p1.brickData,p1.curPosX,p1.curPosY, p1.curRot, -p1.playerNo);
			}


			// apply rotation code 
			if (p1.velR != 0) {
				grid.insertBlk(p1.brickData,p1.curPosX,p1.curPosY, p1.curRot, 0);
		
				// kick check
				// try normal rotation...

				let rotTest = p1.curRot + p1.velR;
				if (rotTest < 0) rotTest = 3;
				else if (rotTest > 3) rotTest = 0;
				// check if rotation is legal
				result = grid.checkBlk(p1.brickData,p1.curPosX,p1.curPosY,0,0,rotTest);
		
				// if NOT legal rotation find a suitable way to rotate
				if (result != 0 ) { // 
					if(DEBUG)console.log("KICK CHECK");
				
					let xyArray = [];
					let testNo = 0;
					while (result != 0 && testNo < 4) {
						
						xyArray = blk.getKickData(p1.brickIndex,p1.curRot, p1.velR,testNo);

						if(DEBUG)console.log("in while loop " + p1.curRot + ">>" + p1.velR + "  testno:" + testNo + "xyArray" + xyArray);
						result = grid.checkBlk(p1.brickData,p1.curPosX + xyArray[0],p1.curPosY + xyArray[1], 0,0, rotTest);
					
						testNo++;
						if (gSettings.SIMPLE_ROTATION == true && testNo > 1) break;
					}
					if(DEBUG)console.log("tests finished result: " + testNo);

					if (testNo == 4 || (gSettings.SIMPLE_ROTATION == true && testNo > 1)) {
						if(DEBUG)console.log("tests failed")
						p1.velR = 0; 

					} else {
						if(DEBUG)console.log("tests passed applying offsets")
						p1.curPosX += xyArray[0];
						p1.curPosY += xyArray[1];
						p1.velX = 0;
						p1.velY = 0;
					}
				
				
					// https://tetris.fandom.com/wiki/SRS

				}
		
				// OK tests are completed now lets actually rotate the block
				if (p1.velR != 0) {
					p1.rotateBlk();
				}
			}

			// hard drop -- logic
			if (p1.hardDropOn == true) {
				// keep moving down until hit
				p1.hardDropOn = false;
				let movement = 0;
			
				result = 0;
				p1.velY = 0;
				p1.velX = 0;
				grid.findAndReplaceFromArray(-p1.playerNo,0);
				grid.insertBlk(p1.brickData,p1.curPosX,p1.curPosY, p1.curRot, 0);

				// add hardblock shake here...
				// add fx here
			
				while (result == 0) {
					movement += 1;
					result = grid.checkBlk(p1.brickData,  p1.curPosX, p1.curPosY, p1.velX, p1.velY + movement, p1.curRot) 
				}
				
				p1.curPosY += movement - 1;
			    p1.hardDropPlaced = true;
				p1.score += (gSettings.Score_Hard_drop * movement);

			} else {
				// regular check
				result = grid.checkBlk(p1.brickData,  p1.curPosX, p1.curPosY, p1.velX, p1.velY, p1.curRot) 
			}

		
		

			// check if any cols inside the grid...
			if (result == -2 ||result == 1 || result == 2 || result == 4 ) { // 4 is x and y 1 is another piece Y 2 is another piece X -2 is hitting floor
			//	console.log("brick hit... " + result + "vx " + p1.velX + "vy " + p1.velY);
				if (gSettings.STICKY_BRICKS == false && result == 2) {
					// if bricks aren't sticky don't force collision on X - just stop movement
					p1.velX = 0;
					result = 0;
				} else { // commit the bricks
				p1.mosXY = [];
				p1.mosXY = grid.insertBlk(p1.brickData,p1.curPosX,p1.curPosY, p1.curRot, p1.brickIndex + 1 ); // was 1

				if (gSettings.FADE_ENABLE) {
					for (let j = 3; j < 11; j += 2) {
						
						this.flashBlk(this.getPosXFromGrid(p1,p1.mosXY[j]), this.getPosYFromGrid(p1,p1.mosXY[j + 1]), p1.color);  			
					}
				}
/*
				this.flashBlk(this.getPosXFromGrid(p1,p1.mosXY[3]), this.getPosYFromGrid(p1,p1.mosXY[4]), p1.color);  			
				this.flashBlk(this.getPosXFromGrid(p1,p1.mosXY[5]), this.getPosYFromGrid(p1,p1.mosXY[6]), p1.color);  			
				this.flashBlk(this.getPosXFromGrid(p1,p1.mosXY[7]), this.getPosYFromGrid(p1,p1.mosXY[8]), p1.color);  			
				this.flashBlk(this.getPosXFromGrid(p1,p1.mosXY[9]), this.getPosYFromGrid(p1,p1.mosXY[10]), p1.color);  			
*/	
					
				if (p1.hardDropPlaced == true) {
					if (gSettings.SMOKE_ENABLE)	this.smokeSpawn(this.getPosXFromGrid(p1, p1.mosXY[0]) - p1.mosXY[2],this.getPosYFromGrid(p1, p1.mosXY[1]),p1.color, mJS.getRandomInt(4,10));	
				
					
				
				}
				
				

				let lines =  grid.lineCheck();
				if (lines > 0) {

					sndLib[Sound.startGame].play();
					p1.linesCleared += lines; // check to see if line has been made and move data down...
				
					if (	p1.hardDropPlaced == true) {
						p1.ratScore += 50;
					}
					p1.score += (gSettings.Score_Combo * p1.comboAmount) * p1.level;
					p1.comboAmount = 0; 
					switch(lines) {
						case 1:
						    p1.score += gSettings.Score_Single_Line * p1.level;
							break;
						case 2:
							p1.score += gSettings.Score_Double_Line * p1.level;
							break;

						case 3: 
							p1.score += gSettings.Score_Triple_Line * p1.level;	
							break;

						case 4:
							p1.score += gSettings.Score_Quad_Line * p1.level;	
							break;

					}

					// progress level
					if (   (gSettings.RAT_SCORE_SYSTEM == false && p1.linesCleared >(p1.level * gSettings.LEVEL_PROGRESSION_AMOUNT) && p1.level < gSettings.LEVEL_SPEEDS.length) 
						|| (gSettings.RAT_SCORE_SYSTEM == true && p1.ratsHomed > (p1.level * gSettings.LEVEL_PROGRESSION_AMOUNT) && p1.level < gSettings.LEVEL_SPEEDS.length) 
						) {
						 	p1.setLevel(p1.level + 1);

							if (gSettings.RAT_SCORE_SYSTEM == true) {
								grid.spawnRat(1);
								grid.spawnRat(1);
								grid.spawnRat(1);
		


							}
						}

					

				} else {
					p1.comboAmount = 0;
				}
				p1.hardDropPlaced = false;
				sndLib[Sound.placeBrick].play();
				p1.nextBrick();
				}

			}
			else if (result == -3 || result ==  -4 ) {

				//console.log("brick OFB...");
				
		
				
				p1.velX = 0;
				result = 0;
			} 

			if (result == 0) {
			
				//console.log("move brick...");
				grid.findAndReplaceFromArray(-p1.playerNo,0);
				grid.insertBlk(p1.brickData,p1.curPosX,p1.curPosY, p1.curRot, 0);	// remove previous pos

				p1.curPosX +=  p1.velX;
				p1.curPosY +=  p1.velY;

				p1.velX = 0;
				p1.velY = 0;
				
				if (p1.PlayerMovedY == 1) {
					p1.score += gSettings.Score_Soft_drop;
					p1.PlayerMovedY = 0;
				}

				grid.insertBlk(p1.brickData,p1.curPosX,p1.curPosY, p1.curRot, -p1.playerNo);
			//	grid.insert(p1.curPosX,p1.curPosY, 3);
			}


		}


		///////////// end of player input

		// remove the players from the array .. as working out stuff

		grid.insertBlk(p1.brickData,p1.curPosX,p1.curPosY, p1.curRot, 0);

		/// UPDATE STUFF
		if (gSettings.LINE_CLEAR_DELAY == true) {
			if (grid.rowsReadyToClear == true ) {
				grid.rowsReadyToClear = false;
				grid.rowsClearTimeSet = true;
				grid.rowsClearNextTime = time + gSettings.LINE_CLEAR_DELAY_TIME;
				//grid.lineSetRowArray(grid.rowsToClear,11);
				grid.lineSetRowArrayPaint(grid.rowsToClear);
			}

			if (grid.rowsClearNextTime < time && grid.rowsClearTimeSet == true ) {

				grid.lineClearRowArray(grid.rowsToClear, true) ;
				grid.rowsClearTimeSet = false;
				this.ratScoreCheck(p1,grid); // NOTE all players should get rat bonus so need to extend this function to allow multiple
			}
		}
		
	//	grid.updateRats(time, delta);

	grid.updateRats(time, delta);
	grid.insertRatsIntoArray();

	// put the player back in
	grid.insertBlk(p1.brickData,p1.curPosX,p1.curPosY, p1.curRot, -p1.playerNo);
	
		
		////////////
		// todo this code doesn't work for multiple players


	}

///	DRAW STUFF

		this.draw(delta, time);


		if (DEBUG)	{ //terminal.report();

			debugText.setText('Delta: ' + delta.toFixed(2) + '  Time: ' + time + 
			"\nCX:" + p1.curPosX + "CY:" + p1.curPosY + " rot:" + p1.curRot + " lines:" + p1.linesCleared + "bag:" + p1.brickBag + 
			"\nLevel: " + p1.level + " Score:" + p1.score + " Rat Score: " + p1.ratScore + " TOP SCORE " + topScore + 
			"\nratsH =" + p1.ratsHomed + " FreeRats " + grid.noRoamingRats + " NestedRats " + grid.noNestedRats + " Total " + grid.totalRatCount + " RatArrayLegnth " + grid.rats.length +
			"\n rows already" + grid.ratsRowsAlreadySpawned 
			);
			

			if (debugGrid)
				debugText.setText(debugText.text + "\n" + grid.report());



		

			this.input.keyboard.on('keydown', event =>
			{
	
				if (event.keyCode === Phaser.Input.Keyboard.KeyCodes.G)
				{
					//debugGrid = !debugGrid;
					console.log(grid.gridArray);
				}

				if (event.keyCode === Phaser.Input.Keyboard.KeyCodes.R) {
				
					grid.zero();
					p1.initPlayer();
					grid.spawnRat(0,0);
					//grid.spawnRat(0,1);

					let br = gSettings.GAME_GRID_SIZE_Y -1;
				
					for (let i = 0; i < gSettings.GAME_GRID_SIZE_X;i++) {
		
				
						grid.insert(i,br -3,1);
						grid.insert(i,br -2,1);
						grid.insert(i,br -1,1);
						grid.insert(i,br ,1);
	
					}
					grid.insert(2,br - 3,0);
					grid.insert(4,br - 3,0);
					grid.insert(5,br - 3,0);
					grid.insert(8,br - 3,0);
					grid.insert(9,br - 3,0);
					grid.insert(2,br - 3,0);
					grid.insert(8,br - 2,0);
					grid.insert(9,br - 2,0);

					grid.insert(2,br - 1,0);
					grid.insert(1,br -1 ,0);
					grid.insert(3,br - 1,0);
	
					grid.insert(0,br ,0);
	

				}
	

			
				if (event.keyCode === Phaser.Input.Keyboard.KeyCodes.U) {
					grid.zero();
					for (let i = 0; i < 10;i++) {
						grid.insert(mJS.getRandomInt( 0, gSettings.GAME_GRID_SIZE_X- 1),mJS.getRandomInt( 0, gSettings.GAME_GRID_SIZE_Y - 1),1);
					}
					let result = grid.lineCheck(); // check to see if line has been made and move data down...
				}

				if (event.keyCode === Phaser.Input.Keyboard.KeyCodes.N) {
					grid.zero();
					grid.spawnRat(1);
					grid.spawnRat(1);
					grid.spawnRat(1);
				}

		
				if (event.keyCode === Phaser.Input.Keyboard.KeyCodes.L  && debugKey < time) {
					
					
					let i = 0;
					console.log("TEST" + p1.gridPosXCent);
					
					debugKey = time + 500;

					var text = "Yeah!" + i + " Saved " + 400 + " points"; 

					this.createMovingText(p1.gridPosXCent,p1.gridPosYBot,text);
					/*
					let found = 0;
					for(i = 0; i < movingTextArr.length; i++) {
						if (movingTextArr[i].y == gSettings.GAME_Y_RES + 1000) {
							console.log("found text + " + i );
							found = 1;
							break;
						}
					}
					if (found == 1) 
					{
						console.log("text made");
						movingTextArr[i].y = bottomOfGrid;
					
						movingTextArr[i].setText("hello mat");
					}
					*/
				}

				if (event.keyCode === Phaser.Input.Keyboard.KeyCodes.O && debugKey < time) {
					p1.level--;
					debugKey = time + 500;
					if (p1.level > 20) p1.level = 20;
					if (p1.level < 0) p1.level = 0;
					p1.setLevel(p1.level);
				}

				if (event.keyCode === Phaser.Input.Keyboard.KeyCodes.P && debugKey < time) {
					p1.level++;
					debugKey = time + 500;
					if (p1.level > 20) p1.level = 20;
					if (p1.level < 0) p1.level = 0;
					p1.setLevel(p1.level);
				
				}

				if (event.keyCode === Phaser.Input.Keyboard.KeyCodes.W) {
				
					grid.zero();
					p1.initPlayer();
					
					grid.spawnRat(0,1);
					grid.spawnRat(0,2);
					grid.spawnRat(0,3);
					grid.spawnRat(0,4);
					grid.spawnRat(0,5);
					grid.spawnRat(0,6);
					grid.spawnRat(0,7);
					grid.spawnRat(0,8);
					
				
					for (let i = 0; i < gSettings.GAME_GRID_SIZE_X;i++) {
		
				
						grid.insert(i, gSettings.GAME_GRID_SIZE_Y -1,1);
		
	
					}
				
					grid.insert(8, gSettings.GAME_GRID_SIZE_Y -1,0);
					grid.insert(7, gSettings.GAME_GRID_SIZE_Y -1,0);
					grid.insert(1, gSettings.GAME_GRID_SIZE_Y -1,0);
	
				}

				if (event.keyCode === Phaser.Input.Keyboard.KeyCodes.E) {
				
					grid.zero();
					p1.initPlayer();
					grid.spawnRat(0,1);
					grid.spawnRat(0,1);
					grid.spawnRat(0,1);
					grid.spawnRat(0,1);
					let br = gSettings.GAME_GRID_SIZE_Y -1;
				
					for (let i = 0; i < gSettings.GAME_GRID_SIZE_X;i++) {
		
				
						grid.insert(i,br,1);
		
	
					}
					grid.insert(5,br - 1,1);
					grid.insert(6,br,0);
					grid.insert(7,br,0);
					grid.insert(8,br,0);
					grid.insert(9,br,0);
	

				}
	

				if (event.keyCode === Phaser.Input.Keyboard.KeyCodes.U) {
				
					grid.zero();

					

					
		
	
					for (let i = 0; i < gSettings.GAME_GRID_SIZE_X;i++) {
		
					
						grid.insert(i,18,1);
	
					}
				
					grid.insert(5,18,0);
					
					let result = grid.lineCheck(); // check to see if line has been made and move data down...
					
			
				}
			});
		
		}
	}

	// TODO move the score to be owned by player
	// HINTuse 
	drawMovingText(delta, player) {
	
		const TEXT_SPEED = 2.25;
		for(let i = 0; i < movingTextArr.length; i++) {
			if (movingTextArr[i].y == gSettings.GAME_Y_RES + 1000) continue;

			movingTextArr[i].y -= (TEXT_SPEED );
//			movingTextArr[i].alpha -=  (0.0001 );
		
//		    this.bringToTop();

		 if ( movingTextArr[i].y < player.gridPosYTop) movingTextArr[i].y = gSettings.GAME_Y_RES + 1000;
//		 if ( movingTextArr[i].y < -100) movingTextArr[i].y = gSettings.GAME_Y_RES + 1000;

		}


	}

	createMovingText(xPos, yPos, Str, tint, scale) {

		let i = 0;

	
		let found = 0;
		for(i = 0; i < movingTextArr.length; i++) {
			if (movingTextArr[i].y == gSettings.GAME_Y_RES + 1000) {
				found = 1;
				break;
			}
		}

//		

		if (found == 1) 
		{
			sndLib[Sound.bonus].play();
			movingTextArr[i].setStyle({
				fontFamily:"PixeloidMono",	
				fontSize:15,
				color:'#ffffff'
			});

			movingTextArr[i].setOrigin(0.5, 0.5);
			movingTextArr[i].depth = 100; // how to bring things to the front or back
			movingTextArr[i].y = yPos;
		    movingTextArr[i].x = xPos;
			movingTextArr[i].alpha = 1;
			movingTextArr[i].setText(Str);
			movingTextArr[i].setTint(tint);
			movingTextArr[i].scale = scale;
			//movingTextArr[i].setStroke(0x000000,20);
			movingTextArr[i].setShadow(5,5,0x000000,2,true,true);
		}
	}

	// ratscore
	ratScoreCheck(player, grid) {
		let homed = 0;
		let ratsCleared = grid.getRatsClearedArray();
		if(DEBUG)console.log("RATS CLEARED = " + ratsCleared );

		let bonusAmount = 0;
		let ratPoints = 0;
		if (ratsCleared.length > 0) {
			for (let i = 0; i < ratsCleared.length; i++) {
		
				ratPoints += (gSettings.Score_Rat_Value[ratsCleared[i] - 8]);
				player.ratScore +=  (gSettings.Score_Rat_Value[ratsCleared[i] - 8]) * player.level;
				player.ratsHomed++;
				homed++;

			}
			let ratClearedAmount =  ratsCleared.length;
			// drawRatHomedMessage(player, ratClearedAmount); -- TODO add this score message
		
		
			if (ratClearedAmount > gSettings.Score_Rat_Multi_Bonus.length) {
				bonusAmount = gSettings.Score_Rat_Multi_Bonus.length - 1;
			}
			bonusAmount = gSettings.Score_Rat_Multi_Bonus[ratClearedAmount] * player.level;
			player.ratScore += bonusAmount;
			var text = "Saved" + homed + "Wopilkara's\n" + bonusAmount + "points!"; 
			//this.createMovingText(player.gridPosXCent,player.gridPosYBot,text);
			UI.RatBonusSavedTxt.alpha = 1;

			UI.RatBonusNumTxt.alpha = 1;
			UI.RatBonusScoreTxt.alpha = 1;
			UI.RatBonusNumTxt.scale = 1;
			
			text = homed + " ";
			UI.RatBonusNumTxt.text = text;
			var displayAmount = (ratPoints * player.level) + bonusAmount;
			text = displayAmount + " Points!"
			UI.RatBonusScoreTxt.text = text;
			
			UI.RatBonusNumTxt.setTint(0xb59c81);
			UI.RatBonusScoreTxt.setTint(0xb59c81);
			UI.RatImg.alpha = 1;

			if (homed > 20) homed = 20;
			UI.RatBonusScoreTxt.setTint(gSettings.LEVEL_COLORS[homed]);
			UI.RatBonusNumTxt.setTint(gSettings.LEVEL_COLORS[homed]);
			
			this.createMovingText(p1.gridPosXCent + 147 ,p1.gridPosYBot - 100,text, gSettings.LEVEL_COLORS[homed], gSettings.TILE_SCALE + ( homed * 0.1));

		
		}
	
	}


	// Various Drawing Functions

	// master draw calls
	draw(delta, time) {
	

		
		this.UIdraw();
	
		if (GAME_ON == true) {
		this.drawGrid(grid, p1, gSettings.GRID_X_POS , gSettings.GRID_Y_POS, time, delta);
		this.drawRats(grid, p1, gSettings.GRID_X_POS ,gSettings.GRID_Y_POS, time, delta);
		this.drawFXs(time,delta);
		
		this.drawMovingText(delta, p1);

		if (p1.redrawNext == true) {
			p1.redrawNext = false;
			nextBlocks.getChildren().forEach(function(item) {
				item.destroy();
			}, this);

			this.drawNext(p1, 840, 85, gSettings.DRAW_NEXT_AMOUNT, false);
		};
	}

	}

	UIInputChk(time,player) {


		for (let i = 0; i < UI.ButtonUIString.length; i++) {

			switch(UI.ButtonUIString[i]) {
				case "MoveLeft":
					player.btnMoveLeft = true;
				break;
				case "MoveRight":
					player.btnMoveRight = true;
				break;
				case "RotCCW":
					player.btnRotateCCW = true;
				break;
				case "RotCW":
					player.btnRotateCW = true;
				break;
				case "Drop":
					player.btnDrop = true;
				break;
				case "HardDrop":
					player.btnHardDrop = true;
				break;
				case "RestartGame": 
				if (GAME_ON == true) {
					// LOAD GAME OVER
					TITLE_SCREEN_ON = true;
					GAME_ON = false;
					GAME_OVER_WAIT = time + 7000;
					grid.zero();
					this.drawNext(p1,840, 85, gSettings.DRAW_NEXT_AMOUNT, true)
					UI.TitleState = 4;
					for(let k = 0; k < movingTextArr.length; k++) {
						movingTextArr[k].setText(" "); 
					}
					newGame = true;
					sndLib[Sound.ratGameOver].play();
					grid.findAndReplaceFromArray(-p1.playerNo,0);
					grid.insertBlk(p1.brickData,p1.curPosX,p1.curPosY, p1.curRot, -p1.playerNo);
				}
				break;
			}

		}

		UI.ButtonUIString.length = 0;
	}

	UIdraw() {
		if (UI.inited == true) {
			UI.TopScoreTxtVal.text = topScore;
			UI.YourScoreTxtVal.text = p1.ratScore;
			UI.LevelTxtVal.text = p1.level;
			UI.HomedTxtVal.text = p1.ratsHomed;
			UI.update(gTime);
		}
	}

	drawNext(player,drawPosX, drawPosY, amount, blankIt ) {

			if (amount == 0) return;


			let j = 0;
			var tile;
			let startingPosX = drawPosX;
			let startingPosY = drawPosY;
			let xpos = startingPosX; // starting position  X
			let ypos = startingPosY; // starting position Y
			let tileSize = gSettings.TILE_SIZE;
			let tileScale = gSettings.NEXT_BLOCK_TILE_SCALE;
		
			let as = 4;
			var nextGridArray = [[]];
			var index;
			var brickData;
			let y = 0;
			let x = 0;

			for (j = 0; j < amount; j++) {

			x = 0;
			y = 0;
			xpos = startingPosX; // starting position  X
		

			// make the next Grid Array
		
			nextGridArray = [[]];
			nextGridArray = new Array(as); // create an empty array of length x
			for (x = 0; x < as; x++) { // how many rows
				nextGridArray[x] = new Array(as); // make each element an array
			}

			for (x = 0; x < as; x++ ) { // how long is each row...
				for (y = 0; y < as; y++) { // how long is each column
					nextGridArray[x][y] = 0;
				} 
			}

			// get the brick data && put into array
			var index = player.brickBag[j];
			var brickData = blk.nextBlkTypes[index];
		
			var yOff = 0;
			var xOff = 0;

			
			
				// fill the array
			for (x = 0; x < brickData.length; x++) {
			 
			  if (brickData[x] == 1) {
				
				nextGridArray[yOff][xOff] = 1;
			  }
			  xOff++;
			  if (xOff > 3 || brickData[x] == 2) {yOff++; xOff = 0;}
		 
			}

		

			// draw the tiles
			for (y = 0; y <  as; y++ ) { // columes
				for (x = 0; x < as; x++) { // row
					
					if (nextGridArray[y][x] >= 1 && blankIt == false) {
					
						tile = this.add.sprite(xpos,ypos, 'tile0.gfx');
						tile.scale = tileScale;
						tile.setOrigin(0,0);	
						nextBlocks.add(tile);
						tile.setTint(player.color); // player color
					} else {
						
						tile = this.add.sprite(xpos,ypos, 'blank.gfx');
						tile.scale = tileScale;
						tile.setTint(gSettings.LEVEL_COLORS[player.level]);
						tile.setOrigin(0,0);	
						nextBlocks.add(tile);	
						


					}
  					 xpos += (tileSize * tileScale); // tile offset
				 
				}
				xpos = startingPosX; 
				ypos += (tileSize * tileScale);
				
			}


			ypos += (tileSize * tileScale);
			

		}
	


	}

	// draw FXs
	drawFXs(time,delta) {
	
		sprFXs.getChildren().forEach(function(fx) { 
			if( fx.fadeOut == true) {
	   			fx.alpha -= fx.fadeOutSpd;
			}

			if (fx.dieTime < time) {
				fx.destroy();
			}
			if (fx.rotate == true) {
				fx.angle += fx.rotationAmount;
			}
		},this);


	}


	drawRats(grid, player, drawPosX, drawPosY, time, delta) {
		let i = 0;
		let ratSpr ;
		let tileSize = gSettings.TILE_SIZE;
		let tileScale = gSettings.TILE_SCALE;
		let hiddenOffSet = gSettings.NO_OF_HIDDEN_TOP_ROWS;
		for(i = 0; i < grid.rats.length; i++) {

			if (grid.rats[i].hasSprite == false) {
				ratSpr = this.add.sprite(-100,-100, 'RatRunA.gfx');
				ratSpr.setOrigin(0,0);
				ratSpr.scale = tileScale;
				ratSpr.id = grid.rats[i].id;
				ratSprites.add(ratSpr);
				ratSpr.depth = 90;
				ratSpr.isDying = false;
				ratSpr.scoreTake = 0;
				sndLib[Sound.ratSpawn].play();
				switch(grid.rats[i].ratType) {
					case 8:
					default:
						ratSpr.aniKeys = ["aniM1Run","aniM1Fall","aniM1Nest", "aniM1Die", ];
						ratSpr.scoreTake = 0;

						break;
					case 9:
						ratSpr.aniKeys = ["aniM2Run","aniM2Fall","aniM2Nest", "aniM2Die", ];
						ratSpr.scoreTake = 1;

						break;
					case 10:
						ratSpr.scoreTake = 2;

						ratSpr.aniKeys = ["aniM3Run","aniM3Fall","aniM3Nest", "aniM3Die", ];
					break;


				}
				ratSpr.curAni = -1;
				ratSpr.isHomed = false;
		
				grid.rats[i].hasSprite = true;
			}

		}
			/*
			if (ratSprites[i].id == grid.rats[i].id) {
				console.log("ratfound!");


			}
			*/

		ratSprites.getChildren().forEach(function(rat) { 
			let i = grid.getRatIndexByID(rat.id);

			if (rat.isHomed == true) {
				
				rat.alpha -= 0.1;
			//	rat.scale += 0.05;
		
				if (rat.alpha <= 0) { rat.destroy();   }
				return;
			}

			if (rat.isDying == true) {
			
				rat.alpha -= 0.1;
				rat.play(rat.aniKeys[3]);
			//	rat.scale += 0.05;
		
				if (rat.alpha <= 0) { rat.destroy();   }
				return;

			}



			if (i == -1) { rat.destroy();  return; }
		
			
		
			
			

			

		
	



				if (grid.rats[i].direction == -1) rat.flipX = 1;
				if (grid.rats[i].direction == 1) rat.flipX = 0;
	
				if (grid.rats[i].currentlyNested == true && rat.curAni != 2) { sndLib[Sound.ratNest].play(); rat.play(rat.aniKeys[2]); rat.curAni = 2; }
	
				else if (grid.rats[i].isFalling == true && rat.curAni != 1) { rat.play(rat.aniKeys[1]); rat.curAni = 1; }
				
				else if (rat.curAni != 0 && grid.rats[i].isFalling == false && grid.rats[i].currentlyNested == false ) {
					rat.play(rat.aniKeys[0]); rat.curAni = 0;
				}
				
				
			
			if (grid.rats[i].isHomed == true) { rat.isHomed = true; }

			rat.x = drawPosX +  (grid.rats[i].posX  * (tileSize * tileScale));
			rat.y = drawPosY + ((grid.rats[i].posY - hiddenOffSet) * (tileSize * tileScale));

			if ( (grid.rats[i].killRat == true && grid.rats[i].isHomed == false) || grid.rats[i].killSprite == true) {	sndLib[Sound.ratDie].play();  rat.isDying = true; player.ratScore -= (gSettings.Score_Rat_Value[rat.scoreTake] * player.level); 
		//		var text = "Rat died\n" +  -(gSettings.Score_Rat_Value[rat.scoreTake]) + "Points!";
	//			this.createMovingText(p1.gridPosXCent + 147 ,p1.gridPosYBot - 100,text, 0xff0000, gSettings.TILE_SCALE);
			}

		
		},this);


	}

	drawGrid(grid, player, drawPosX, drawPosY, time, delta) {

			// run this twice to ensure all is removed --
			blocks.getChildren().forEach(function(item) {
				if (item.name == 'blockExp' && item.dieTime > time) {
					item.alpha -= 0.01;
					item.angle += item.rotationAmount;
				}
				else if (item.name == 'zoom' && item.dieTime > time) {
					item.alpha -= 0.01;
					item.scale += item.scaleAmount;
			
				}
			
				else 
					item.destroy();
			}, this);


			/*
			blocks.getChildren().forEach(function(item) {
				item.destroy();
			}, this);
		*/
			var tile;
			let startingPosX = drawPosX;
			let startingPosY = drawPosY;
			let xpos = startingPosX; // starting position  X
			let ypos = startingPosY; // starting position Y
			let tileScale = gSettings.TILE_SCALE;
			let tileSize = gSettings.TILE_SIZE;
			let y = 0;
			let x = 0;
			let r = 0;
			let explode = false;
			let zoom = false;
			// -1,-2,-3,-4 player... -8 -9 -10 rat, 0 - 7 tiles, 8 9 10nestedrat
			for (y = gSettings.NO_OF_HIDDEN_TOP_ROWS; y <  gSettings.GAME_GRID_SIZE_Y; y++ ) { // columes
		
				for (x = 0; x < gSettings.GAME_GRID_SIZE_X; x++) { // row
					// draw players
					if (grid.gridArray[y][x] == -1 || grid.gridArray[y][x] == -2 || grid.gridArray[y][x] == -3 || grid.gridArray[y][x] == -4 ) {
						// draw player
						tile = this.add.sprite(xpos,ypos, 'tile0.gfx');
						tile.scale = tileScale;
						tile.setOrigin(0,0);
						
						blocks.add(tile);
						tile.setTint(player.color); // player color
					}

					if (grid.gridArray[y][x] >= 100) {
						explode = true;
						grid.gridArray[y][x] = grid.gridArray[y][x] / 100;
					}
					
					if (grid.gridArray[y][x] >= 1 ) {
					// draw blocks
					switch(grid.gridArray[y][x]) {
						case 1:
							default:
							tile = this.add.sprite(xpos,ypos, 'tile1.gfx');
							break;
						case 2:
							tile = this.add.sprite(xpos,ypos, 'tile2.gfx');
							break;
						case 3:
							tile = this.add.sprite(xpos,ypos, 'tile3.gfx');
						break;
						case 4:
							tile = this.add.sprite(xpos,ypos, 'tile4.gfx');
						break;
						case 5:
							tile = this.add.sprite(xpos,ypos, 'tile5.gfx');
						break;
						case 6:
							tile = this.add.sprite(xpos,ypos, 'tile6.gfx');
						break;
						case 7:
							tile = this.add.sprite(xpos,ypos, 'tile7.gfx');
						break;
						// draw rats as tiles...
						case 8:
						case 9:
						case 10:
							
							if (explode == false) {
							tile = this.add.sprite(xpos,ypos, 'blank.gfx');
							tile.scale = tileScale;
							tile.setTint(gSettings.LEVEL_COLORS[player.level]);
							tile.setOrigin(0,0);
						
							blocks.add(tile);	
							}
							if (explode == true) {
								r = grid.getRatIndexAtPos(y,x);
								if (r != -1) {
							//		grid.rats[r].killRat = true;
									grid.rats[r].isHomed = true;
								}
							//	grid.gridArray[y][x] = 0;
								explode = false;
							}
							/*
							r = grid.getRatIndexAtPos(y,x);
							if (r != -1) {
								tile = this.add.sprite(xpos,ypos, 'RatNestA.gfx'); // look up table to go here
								if (grid.rats[r].direction == -1) { tile.flipX = 1; }
							} else {
							tile = this.add.sprite(xpos,ypos, 'tile8.gfx');
							}
							*/
/*
							if (explode == true) {
								explode = false;
								zoom = true;
							}
*/							

						break;
				

						break;
						case 11:
						// draw killed lines
	/*
						tile = this.add.sprite(xpos,ypos, 'blank.gfx');
						tile.scale = tileScale;
						tile.setTint(0x000000);
						tile.setOrigin(0,0);
						blocks.add(tile);	
*/
					
				

									
							tile = this.add.sprite(xpos,ypos, 'blank.gfx');
							
							
							
						break;
						}
					
						if (explode == true) {


							tile.name = "blockExp";
							tile.dieTime = time + 4000;
							//tile.play('fadeLineAni');
							tile.depth = 80;
							tile.alpha = 0.7;
							this.physics.world.enable(tile);
							tile.body.gravity.y = 500;
							tile.rotationAmount = mJS.getRandomInt(-5,5);
							tile.body.velocity.x = mJS.getRandomInt(-300,300);
							tile.body.velocity.y = mJS.getRandomInt(-500,10);									
							grid.gridArray[y][x] = 0;
				
							explode = false;
						}

						if (zoom == true) {
							zoom = false;
							tile.name = "zoom";
							tile.dieTime = time + 3000;
							//tile.play('fadeLineAni');
							tile.depth = 90;
							tile.alpha = 0.8;
							tile.setOrigin(0.5,0.5);
							tile.scaleAmount = 0.5;									
						
						}
					tile.scale = tileScale;				
					tile.setOrigin(0,0);	
					blocks.add(tile);
			
				   }
				   if (grid.gridArray[y][x] == 0) {
				
					tile = this.add.sprite(xpos,ypos, 'blank.gfx');
					tile.scale = tileScale;
					tile.setTint(gSettings.LEVEL_COLORS[player.level]);
					tile.setOrigin(0,0);
				
					blocks.add(tile);
				
				   }
				   if (grid.gridArray[y][x] == -8 || grid.gridArray[y][x] == -9 || grid.gridArray[y][x] == -10) { // rat
				
					tile = this.add.sprite(xpos,ypos, 'blank.gfx');
					tile.scale = tileScale;
					tile.setOrigin(0,0);			
					tile.setTint(gSettings.LEVEL_COLORS[player.level]);
					blocks.add(tile)
					/*
					r = grid.getRatIndexAtPos(y,x);
					if (r != -1) {
						tile = this.add.sprite(xpos,ypos, 'RatRunC.gfx'); // look up table to go here
						if (grid.rats[r].direction == -1) { tile.flipX = 1; }
					} else {

					tile = this.add.sprite(xpos,ypos, 'tile9.gfx');
					}
					tile.scale = tileScale;
					tile.setOrigin(0,0);
					blocks.add(tile);
					*/
				   }
				   xpos += (tileSize * tileScale)  ; // tile offset
				 
				}
				player.gridPosXRight = xpos + (tileSize * tileScale);
				xpos = startingPosX; 
				ypos += (tileSize * tileScale);
			}
			player.gridPosYBot = ypos;
			player.gridPosXLeft = startingPosX;
			player.gridPosYTop = startingPosY;
			player.gridPosXCent = player.gridPosXRight - ( player.gridPosXRight / 2 );

	}

	flashBlk(xPos, yPos, tint, ) {
		var spr = this.add.sprite(xPos,yPos, 'blank.gfx');
		spr.dieTime = gTime + 5000;
		spr.depth = 80;
		spr.scale =  gSettings.TILE_SCALE;
		
		spr.setTint(tint);
	
	
		spr.alpha = 1;
		spr.fadeOut = true;
		spr.fadeOutSpd = 0.1;
		spr.setOrigin(0,0);
		sprFXs.add(spr);

	}

	smokeSpawn(xPos, yPos, tint, amount = 1) {
		var spr;
		let xPosA = xPos;
		let yPosA = yPos;
		 
		for (let i = 0; i < amount; i ++) {
		
			if (i > 1) {
				xPosA = xPos += mJS.getRandomInt(-gSettings.TILE_SIZE * 1.5, gSettings.TILE_SIZE * 1.5,);
				yPosA = yPos += mJS.getRandomInt(-gSettings.TILE_SIZE * 1.5, gSettings.TILE_SIZE * 1.5,);
			} 
		spr = this.add.sprite(xPosA,yPosA, 'blank.gfx');
		spr.dieTime = gTime + 5000;
		spr.depth = 80;
		spr.scale =  gSettings.TILE_SCALE;
		spr.play('smokeAni');
		spr.setTint(tint);
		this.physics.world.enable(spr);
		spr.body.gravity.y = 500;
		spr.alpha = 0.8;
		spr.fadeOut = true;
		spr.fadeOutSpd = 0.05;
		spr.rotate = true;
		spr.rotationAmount = mJS.getRandomInt(-10,10);
		spr.body.velocity.x = mJS.getRandomInt(-300,300);
		spr.body.velocity.y = mJS.getRandomInt(-400,10);	
		spr.setOrigin(0,0);
		sprFXs.add(spr);
		}

		

	}

	getPosXFromGrid(player, x) {

		return player.gridPosXLeft + (x * (gSettings.TILE_SIZE * gSettings.TILE_SCALE ));

	}

	getPosYFromGrid(player, y) {

		let hiddenOffSet = gSettings.NO_OF_HIDDEN_TOP_ROWS;

		return player.gridPosYTop + (y - hiddenOffSet) * (gSettings.TILE_SIZE * gSettings.TILE_SCALE );
	}
}